
export default {
    name: 'banner',
    data() {
        return {
            //标签
            labels: {
                id: '0'
            },
            // 存放 bannerLeftSecond 的数据 
            dataNumber: []
        }
    },
    methods: {
        //点击地区获取数据包
        getPackage(id) {
            let address = this.$router.resolve({
                path: '/projectlist',
                query: {
                    id_arr: JSON.stringify([id])
                }
            });
            window.open(address.href, "_blank");
        },
        //获取标签
        getLabel() {
            // console.log('获取标签了')
            this.$getStoreId().then(data => {
                /**
                 * 变量 1 对指定的区域的倾请求 
                 * 变量2 可以传入对象或者是的单个的数据  对相对应的值进行一个更新 
                 *
                */

                this.$post('attribute/search', { shop_id: data, name: '地区', offset: 0, length: 100 }).then(res => {
                    // console.log(res)
                    // res 是我们拿到的数据 
                    this.dataNumber = res.data.result.data[0].attribute_value_type;
                    // console.log(this.dataNumber)
                })
            })
        },


    },

    mounted: function () {
        this.getLabel();
        // console.log(this.$store.state.store.id)
    }
}


